import { UnitEmergencyDto } from '@mark43/cad-api';

function getUnitEmergencyPhysicalLocationDispatchArea(
    unitEmergencyDto: UnitEmergencyDto,
    userAgencyTypeGlobalAttrId: number
) {
    return unitEmergencyDto?.location?.entityLinks?.[0]?.dispatchAreas?.find(
        (dispatchArea) => dispatchArea.agencyTypeGlobalAttrId === userAgencyTypeGlobalAttrId
    );
}

export function shouldShowUnitEmergencyInFr({
    unitEmergencyDto,
    userAgencyTypeGlobalAttrId,
    unitDispatchAreaId,
}: {
    unitEmergencyDto: UnitEmergencyDto;
    userAgencyTypeGlobalAttrId: number;
    unitDispatchAreaId?: number;
}) {
    const physicalLocationDispatchArea = getUnitEmergencyPhysicalLocationDispatchArea(
        unitEmergencyDto,
        userAgencyTypeGlobalAttrId
    );

    // For FR: if the requesting unit's assigned D-Area or physical location D-Area is the same
    // user's unit is assigned to, we show the emergency.
    return (
        (unitEmergencyDto?.unitDispatchAreaId &&
            unitEmergencyDto.unitDispatchAreaId === unitDispatchAreaId) ||
        (physicalLocationDispatchArea && physicalLocationDispatchArea.id === unitDispatchAreaId)
    );
}

export function shouldShowUnitEmergencyInCad({
    unitEmergencyDto,
    userAgencyTypeGlobalAttrId,
    monitoredAndOwnedDispatchAreaIds,
}: {
    unitEmergencyDto: UnitEmergencyDto;
    userAgencyTypeGlobalAttrId: number;
    monitoredAndOwnedDispatchAreaIds: number[];
}) {
    const physicalLocationDispatchArea = getUnitEmergencyPhysicalLocationDispatchArea(
        unitEmergencyDto,
        userAgencyTypeGlobalAttrId
    );

    // For CAD: if user is monitoring or owns the requesting unit's assigned D-Area or physical
    // location D-Area, we show the emergency.
    return (
        (unitEmergencyDto?.unitDispatchAreaId &&
            monitoredAndOwnedDispatchAreaIds.includes(unitEmergencyDto.unitDispatchAreaId)) ||
        (physicalLocationDispatchArea &&
            monitoredAndOwnedDispatchAreaIds.includes(physicalLocationDispatchArea.id))
    );
}
